import { render, staticRenderFns } from "./ListKendaraanRescuePage.vue?vue&type=template&id=0cf35b4f&scoped=true"
import script from "./ListKendaraanRescuePage.vue?vue&type=script&lang=js"
export * from "./ListKendaraanRescuePage.vue?vue&type=script&lang=js"
import style0 from "./ListKendaraanRescuePage.vue?vue&type=style&index=0&id=0cf35b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf35b4f",
  null
  
)

export default component.exports